import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = "Stop Being Your Parents' Tech Support | Grandparent Smartphone Guide";
render(<App data-id="element-201" />, document.getElementById('root'));